import React from 'react';
import { BuildingStorefrontIcon } from '@heroicons/react/20/solid';

import { UItils } from '@nearst/ui';
import styles from '../MyShopNavigation/LocationSelector/LocationSelector.module.scss';

const OnboardingLocationSelector = ({ shop }) => {
	return (
		<div className={styles.button}>
			<OnboardingLocationSelectorButton shop={shop} />
		</div>
	);
};

const OnboardingLocationSelectorButton = ({ shop }) => {
	if (shop?.id) {
		return (
			<div title={shop.name} className={UItils.classnames(styles.shop, styles.current)}>
				<div className={styles.shopImage}>
					{shop.profileImageUrl ? <img alt={shop.name} src={shop.profileImageUrl} /> : <BuildingStorefrontIcon />}
				</div>
				<div className={styles.shopName}>
					<span>
						<span className={styles.truncate}>{shop.name}</span>
					</span>
				</div>
			</div>
		);
	}

	return (
		<div title="Onboarding" className={styles.shop}>
			<div className={styles.shopImage}>
				<BuildingStorefrontIcon />
			</div>
			<div className={styles.shopName}>
				<span>
					<span className={styles.truncate}>Onboarding</span>
				</span>
			</div>
		</div>
	);
};

export default OnboardingLocationSelector;
